// src/api/driverAPI.js
import apiClient from './client';

const DRIVERS_URL = '/api/v1/drivers/';

// Get all drivers
// Update in src/api/driverAPI.js - modify the getDrivers function
export const getDrivers = async (enabled = true) => {
  try {
    const params = { enabled };
    const response = await apiClient.get(DRIVERS_URL, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching drivers:', error);
    throw error;
  }
};

// Add this function to src/api/driverAPI.js
export const getDriverRFIDCards = async (driverId, companyId) => {
  try {
    const response = await apiClient.get(`/api/v1/drivers/${driverId}/rfid_cards`, {
      params: { company_id: companyId }
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching RFID cards for driver ${driverId}:`, error);
    throw error;
  }
};

// Get a single driver by ID
export const getDriver = async (driverId) => {
  try {
    const response = await apiClient.get(`${DRIVERS_URL}${driverId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching driver ${driverId}:`, error);
    throw error;
  }
};

// Create a new driver
export const createDriver = async (driverData) => {
  try {
    const response = await apiClient.post(DRIVERS_URL, driverData);
    return response.data;
  } catch (error) {
    console.error('Error creating driver:', error);
    throw error;
  }
};

// Update a driver
export const updateDriver = async (driverId, driverData) => {
  try {
    const response = await apiClient.put(`${DRIVERS_URL}${driverId}`, driverData);
    return response.data;
  } catch (error) {
    console.error(`Error updating driver ${driverId}:`, error);
    throw error;
  }
};

// Delete a driver
export const deleteDriver = async (driverId) => {
  try {
    await apiClient.delete(`${DRIVERS_URL}${driverId}`);
  } catch (error) {
    console.error(`Error deleting driver ${driverId}:`, error);
    throw error;
  }
};